<template>
  <div class="commodity commodity-main_element-ui">
    <div style="background: #FFFFFF;padding: 15px 25px;margin-top: 30px;">
      <el-row :gutter="10" style="text-align: center">
        <el-col :xs="8" :sm="6" :md="4" :lg="4" :xl="4" style="padding: 15px 0;">
          <div style="font-size: 16px">自定义分类:</div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="4" :xl="4" style="padding: 15px 0;cursor: pointer;font-size: 14px;">
          <div @click="cate='',cate_xuanzhong='',list_data()">全部</div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="4" :xl="4" style="padding: 15px 0;cursor: pointer;font-size: 14px;"
                v-for="(item,index) in list_fenlei.goods_cate" :key="index">
          <el-dropdown placement="bottom" @command="handleCommand">
            <a @click="cate=item.value,cate_xuanzhong=item.value,list_data()"
               :style="cate_xuanzhong==item.value?'color: #0c73db':''">{{ item.label }}
            </a>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item1,index) in item.children" :key="index" :command="item1.value">
                {{item1.label}}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
      </el-row>
    </div>
    <div class="screen">
      <span class="screen_text">综合</span>
      <span class="screen_text_two">
        明码标价
      </span>
      <el-checkbox v-model="checked" @change="mm_biaojia" style="float: left;margin-top: 8px"></el-checkbox>
      <div class="screen_input">
        <el-input size="mini" v-model="input" placeholder="请输入内容"><i slot="suffix" class="el-input__icon el-icon-search"
                                                                     @click="input_sj()"></i></el-input>
      </div>
    </div>
    <!--    <div class="shop">-->
    <!--      <div class="card"  v-for="(item,index) in list" :key="index">-->
    <!--&lt;!&ndash;        {{item}}&ndash;&gt;-->
    <!--        <a v-bind:href="'#/details/' + item.id" >-->
    <!--        <el-image style="height:220px;width: 100%" :src="url+'/storage/'+item.cover" fit="cover">-->
    <!--          <div slot="error" class="image-slot">-->
    <!--            <img style="height:185px" src="../../../assets/home/ecc08ecd42f312b04df547040f2e5f3.png">-->
    <!--          </div>-->
    <!--        </el-image>-->
    <!--        </a>-->
    <!--        &lt;!&ndash;<el-image src="../../../../assets/home/dingwei.png" :fit="fit"></el-image>&ndash;&gt;-->
    <!--        <div class="card_text">-->
    <!--          {{ item.title }}-->
    <!--        </div>-->
    <!--        &lt;!&ndash;        <div class="card_text_evaluate">好评 123   162人购买 </div>&ndash;&gt;-->
    <!--        <div class="card_text_cash">￥{{ item.cash!=='0.00'?item.cash:item.price_yugu }}</div>-->
    <!--      </div>-->
    <!--    </div>-->
    <el-row :gutter="15">
      <el-col :xs="24" :sm="12" :md="6" v-for="(item,index) in list" v-bind:key="index">
        <a v-if="item.api_edition == 2202" v-bind:href="'#/dianpu_new/'+ item.id" class="biaoshi">
          <div class="service-main-background weizhi">
            <el-image class="service-main-picture" :src="url+'/storage/'+item.cover" fit="cover">
              <div slot="error" class="image-slot">
                <img src="../../../assets/home/ecc08ecd42f312b04df547040f2e5f3.png" alt="">

                <!--   <i class="el-icon-picture-outline"></i>-->
              </div>
            </el-image>
            <div class="service-main-background-title" style="margin-top:5px;font-size: 16px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{item.title}}</div>
            <div style="margin-top:5px;color:#666666;">
              <div v-if="item.cash !== '0.00'">价格：￥{{item.cash}}</div>
              <div v-else>价格：面议</div>
            </div>
          </div>
        </a>
        <a v-else v-bind:href="'#/dianpu_index/'+ item.id" class="biaoshi">
          <div class="service-main-background weizhi">
            <el-image class="service-main-picture" :src="url+'/storage/'+item.cover" fit="cover">
              <div slot="error" class="image-slot">
                <img src="../../../assets/home/ecc08ecd42f312b04df547040f2e5f3.png" alt="">

                <!--   <i class="el-icon-picture-outline"></i>-->
              </div>
            </el-image>
            <div class="service-main-background-title" style="margin-top:5px;font-size: 16px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{item.title}}</div>
            <div style="margin-top:5px;color:#666666;">
              <div v-if="item.cash !== '0.00'">明码标价：￥{{item.cash}}</div>
              <div v-else> 预估价格：￥{{item.price_yugu}}</div>
            </div>
          </div>
        </a>
      </el-col>
    </el-row>


    <div data-v-6af373ef="" data-v-5c2776a4="" class="pagination-container" style="line-height: 5.1em;margin-top: 60px">
      <div data-v-6af373ef="" class="el-pagination is-background">
        <span class="el-pagination__total">共 {{ zuoshuL }} 条</span>
        <el-pagination
                style="float: left"
                layout="prev, pager, next"
                @current-change="yedianji"
                :total="zuidayema*10">
        </el-pagination>
      </div>
    </div>

  </div>

</template>
<script>
    export default {

        name: "category",
// /storage/

        data: function () {
            return {
                cate: '',
                list: '',
                cate_xuanzhong: '',
                url: '',
                id: '',
                searchValue: '',
                input: '',
                checked: false,
                zuoshuL: '',
                zuidayema: '',
                list_fenlei: '',
            }
        },
        methods: {

            handleCommand(command) {
                console.log(command);
                this.cate = command;
                this.list_data();
            },
            init() {
                var t = this
                t.url = window.config.api_url
                // console.log(this.$route.params.id)
                t.id = t.$route.params.id
                if (t.$store.state.shopsSearchValue) {
                    t.searchValue = t.$store.state.shopsSearchValue
                }
                if (t.searchValue) {
                    t.input = t.searchValue
                }
                this.list_data()
                this.fenlei()

            },
            fenlei() {
                var t = this
                var url = window.config.api_url + '/college/shop/info?id=' + this.$route.params.id
                t.axios.get(url).then(res => {
                    console.log(res)
                    t.list_fenlei = res.data
                })
            },
            yedianji(e) {
                this.list_data(e)
            },
            list_data(e) {
                var t = this
                var url = window.config.api_url + '/college/goods/list?shop_id=' + this.$route.params.id + '&paginate=16'
                if (e) {
                    url += '&page=' + e
                } else {
                    url += '&page=1'
                }
                if (t.input) {
                    url += '&title=' + t.input
                }
                if (t.checked === true) {
                    url += '&has_price=1'
                }
                if (t.cate) {
                    url += '&goods_cate=' + t.cate
                }
                t.axios.get(url).then(res => {
                    console.log("111111111111111111111")
                    console.log(res.data.data)
                    t.list = res.data.data
                    t.zuoshuL = res.data.total
                    t.zuidayema = res.data.last_page
                })
            },
            mm_biaojia() {
                var t = this
                // console.log(1315546)
                t.list_data()
            },
            input_sj() {
                var t = this
                t.list_data()
            }
        },
        created() {
            this.cate = this.$store.state.click;
            this.cate_xuanzhong = this.$store.state.click;
            this.cate = this.$route.params.value
            
            
            this.init();

        },
        watch: {
            '$store.state.shopsSearchValue'() {
                if (this.$store.state.information !== this.searchValue) {
                    this.init()
                }
            }
        }
    }
</script>
<style lang="less" scoped>
  a {
    text-decoration: none !important;
    color: black;
  }

  .weizhi {
    text-align: center;
  }

  .commodity {
    width: 90%;
    max-width: 1200px;
    margin-right: auto;
    margin-left: auto;
    margin-bottom: 20px;

    .service-main-background {
      overflow: hidden;
      margin-top: 20px;
      height: 248px;
      background-color: #fff;
      border-radius: 3px;

      .service-main-picture {
        height: 185px;
        width: 100%;
      }
    }

    .shop {
      display: flex;
      flex-direction: row; //起点左向右
      flex-wrap: wrap; //换行
      justify-content: space-between; //间隔相等
      .card {
        //flex-grow:1;
        margin-top: 10px;

        width: 228px;
        height: 320px;
        background: #FFFFFF;
        border-radius: 3px;

        .card_text {
          width: 176px;
          margin-left: 30px;
          margin-top: 8px;
          height: 42px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #333333;
          line-height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }

        .card_text_evaluate {
          width: 176px;
          margin-left: 30px;
          margin-top: 8px;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #999999;
          line-height: 20px;
        }

        .card_text_cash {
          width: 176px;
          text-align: center;
          margin-left: 30px;
          margin-top: 10px;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #F03726;
          line-height: 20px;
        }
      }
    }
  }

  .screen {
    width: 100%;
    height: 45px;
    background: #F9F9F9;
    border: 1px solid #D1D1D1;
    border-radius: 3px;
    margin-top: 40px;
    margin-bottom: 30px;
    padding: 0 0;

    .screen_text {
      float: left;
      margin-left: 20px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 45px;
    }

    .screen_text_two {
      float: left;
      //width: 72px;
      //height: 17px;
      margin-left: 50px;
      margin-right: 22px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 45px;
    }

    .screen_input {
      margin-left: 60px;
      margin-top: 8px;
      float: left;
      width: 133px;
    }
  }
</style>
<style lang="less">

  .commodity-main_element-ui {
    .el-input--mini .el-input__inner {
      background: #E1E1E1;
    }

    .el-input.is-active .el-input__inner, .el-input__inner:focus {
      border-color: #4E6EF2;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #4E6EF2;
      border-color: #4E6EF2;
    }

    .el-checkbox__inner:hover {
      border-color: #4E6EF2;
    }
  }

  .el-dropdown-item {
    background-color: #0F325A;
  }
</style>